export default __webpack_public_path__ + "static/media/sellCategoryImage.40494ea3.jpg";